import { useIntercomApi } from '../composables/useIntercomApi'

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { toogleChat, isLoading } = useIntercomApi()

  onNuxtReady(() => {
    watch(
      () => [route.query.chat, isLoading.value],
      ([chatQuery, loading]) => {
        if (chatQuery && !loading) {
          toogleChat({ toogleToState: 'open' })
        }
      },
      { immediate: true },
    )
  })
})
